import { Outlet } from 'react-router';

import { TCustomRouteObject } from '@/shared/types/router.types';

export const userProfileRoutes: TCustomRouteObject = {
  path: '/user-profile/:tabId?',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'profile',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { UserProfileRoute } = await import('./user-profile');
        return { Component: UserProfileRoute };
      },
    },
  ],
};
